import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e1af66b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main tw-overflow-x-hidden" }
const _hoisted_2 = { class: "xl:tw-px-[60px] tw-py-[55px] tw-px-[10px] tw-bg-white" }
const _hoisted_3 = { class: "title-inner" }
const _hoisted_4 = { class: "tw-text-[#211F58] tw-font-semibold" }
const _hoisted_5 = { class: "tw-text-[#211F58] tw-text-[15px]" }
const _hoisted_6 = { class: "tw-py-[40px] xl:tw-py-[55px] xl:tw-px-[60px] tw-px-[10px] roles-container tw-flex tw-gap-[40px]" }
const _hoisted_7 = { class: "tw-flex-col-reverse xl:tw-flex-row content tw-flex-1 tw-max-w-[1182px]" }
const _hoisted_8 = {
  id: "clickbox-role",
  class: "table-content"
}
const _hoisted_9 = { class: "current-roles-container tw-flex" }
const _hoisted_10 = { class: "current-roles-table" }
const _hoisted_11 = { class: "table-header tw-flex tw-items-center tw-justify-between tw-mb-5" }
const _hoisted_12 = { class: "tw-text-[#211F58] tw-text-[18px] tw-font-semibold" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-header tw-flex tw-items-center tw-px-[15px] md:tw-px-[25px] tw-py-[20px] sub-header-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tw-h-[28px] tw-w-[155px] custom-global-skeleton-pulse" })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-content tw-text-sm tw-py-[10px] md:tw-py-10 tw-px-[20px] md:tw-px-10 tw-flex tw-flex-col tw-gap-[25px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tw-h-[28px] tw-w-[195px] custom-global-skeleton-pulse" }),
  /*#__PURE__*/_createElementVNode("div", { class: "tw-h-[76px] tw-w-[100%] tw-rounded-md custom-global-skeleton-pulse" })
], -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "sub-header tw-flex tw-items-center tw-px-[15px] md:tw-px-[25px] tw-py-[20px]" }
const _hoisted_19 = {
  class: "tw-text-[#211F58] tw-text-[18px] tw-font-semibold tw-flex-1",
  "data-cy": "role-management-role-name"
}
const _hoisted_20 = { class: "list-content tw-text-sm tw-py-[10px] md:tw-py-10 tw-px-[20px] md:tw-px-10 tw-flex tw-flex-col tw-gap-[25px]" }
const _hoisted_21 = { class: "tw-font-medium" }
const _hoisted_22 = { class: "grey-color" }
const _hoisted_23 = { class: "tw-font-medium" }
const _hoisted_24 = { class: "grey-color" }
const _hoisted_25 = { class: "content tw-flex tw-flex-col" }
const _hoisted_26 = {
  key: 0,
  class: "card-container"
}
const _hoisted_27 = { class: "tw-flex tw-justify-end" }
const _hoisted_28 = { class: "tw-max-w-[241px] tw-order-[1] md:tw-order-[2] tw-w-[100%] tw-flex tw-justify-center tw-rounded-br-md tw-rounded-bl-md tw-h-[fit-content]" }

import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import CardRolesSetting from "@/components/common/setting/cardRolesSetting.vue";
import ButtonShowMore from "@/components/common/setting/buttonShowMore.vue";
import { Ref, computed, onBeforeUnmount, onMounted, ref, watch } from "vue";
import store from "@/store";
import router from "@/router";
import utilities, { getComponentUiText } from "@/utils/utilities";
import ActionButton, { Action } from "@/components/common/actionButton.vue";
import NoteInfo from "@/components/common/noteInfo.vue";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import backgroundComponent from "@/components/common/backgroundComponent.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import AddRoleModal from "@/components/team/roles/addRoleModal.vue";
import PlusWrappedIcon from "@/components/svgs/plusWrappedIcon.vue";
import UserIcon from "@/components/svgs/userIcon.vue";
import Button1 from "@/components/common/button1.vue";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import AddUserRoleModal from "@/components/team/roles/addUserRoleModal.vue";
import { getMemberOfRoles, deleteRole } from "@/services/org";
import { IOrgRole } from "@/interfaces/org/role";
import { IOrgMemberRes } from "@/interfaces/org/role";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import uniqBy from "lodash/uniqBy";
import ManageUserModal from "@/components/orgManagement/manageUserModal.vue";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import { routers } from "@/utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'rolesManagement',
  setup(__props) {

const showModalAddRole: Ref<boolean> = ref(false);
const showModalAddUser: Ref<boolean> = ref(false);
const roles: Ref<IOrgRole[]> = computed(
  () => store.getters["Org/getOrgRolesData"],
);
const memberOfRoles: Ref<any> = ref({});
const loading: Ref<boolean> = ref(true);
const selectedRole: Ref = ref("");
const selectedRoleName: Ref = ref("");
const backgroundRef = ref(null);
const notInfoVisible = ref(true);
let showModalDeleteRole = ref(false);
const actions: Action[] = [
  {
    icon: PlusWrappedIcon,
    iconColor: "#211F58",
    title: "app-settings-team-roles-actions-menu-add-role-1",
    titleClass: "tw-w-full",
    onClick: () => addRole(),
  },
  {
    icon: UserIcon,
    iconColor: "#211F58",
    title: "app-settings-team-roles-actions-menu-manage-team-1",
    titleClass: "tw-w-full",
    onClick: () => router.push({ path: routers.settingTeamMembers }),
  },
];
const isLoading = computed(() => store.state.Org.isLoadingOrg);
const currentOrg = computed(() => store.state.Org.currentOrg);
const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

watch(currentOrg, async (oldValue: any, newValue: any) => {
  if (newValue.id && oldValue.id && newValue.id !== oldValue.id) {
    store.dispatch("Org/fetchGrantedOrgsList");
  }
});

onMounted(() => {
  store.dispatch("Org/fetchGrantedOrgsList");
  initialData(roles.value);
  window.addEventListener("click", (e: any) => {
    if (!document.getElementById("clickbox-role")?.contains(e.target)) {
      (backgroundRef as any).animation &&
        (backgroundRef as any).animation.reloadToggle();
    }
  });

  EventEmitter.on(EmitterEvents.ROLE_CREATED, async (value: any) => {
    try {
      const members = await getMemberOfRoles(value.member.roleId);
      memberOfRoles.value = {
        ...memberOfRoles.value,
        [`${value.member.roleId}`]: members.data.data.members,
      };
    } catch (error: any) {
      if (error?.data?.message) {
        onShowToast(error.data.message);
      } else if (error?.data?.error?.type) {
        onShowToast(error?.data?.error?.message);
      }

      memberOfRoles.value = {};
    }

    showSuccessToast(
      `"${value.roleTitle}" ${getUiText(
        "app-settings-team-roles-add-role-modal-success-toast-1",
      )}`,
    ); // Role created successfully
  });
});

const showDeleteModal = async (roleId: string) => {
  showModalDeleteRole.value = true;
  selectedRole.value = roleId;
};

onBeforeUnmount(() => {
  window.removeEventListener("click", () => {});
});

const initialData = async (rolesData: any[]) => {
  if (rolesData.length > 0) await fetMemberOfRole(rolesData);
};

watch(roles, async (newValue: any, oldValue: any) => {
  if (!oldValue || oldValue !== newValue) {
    initialData(newValue);
  }
});
const fetMemberOfRole = async (rolesData: any[] = []) => {
  try {
    loading.value = true;
    let promise = [] as any[];
    rolesData.forEach((role: any) =>
      promise.push(getMemberOfRoles(role.roleId)),
    );

    const res = await Promise.all(promise);
    const arrayDataRes: IOrgMemberRes[] = res.map((obj) => obj.data.data);

    const objectDataRes = arrayDataRes.reduce((result, obj) => {
      result[obj.roleId] = obj.members;
      return result;
    }, {});
    memberOfRoles.value = objectDataRes;
  } catch (error: any) {
    if (error?.data?.message) {
      onShowToast(error.data.message);
    } else if (error?.data?.error?.type) {
      onShowToast(error?.data?.error?.message);
    }

    memberOfRoles.value = {};
  } finally {
    loading.value = false;
  }
};

const onShowToast = (messageError: string) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message: messageError,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const showSuccessToast = (message: string) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.SUCCESS,
    message: message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const handleAddUserToRole = ($event) => {
  if ($event && $event.users && $event.users.length)
    updateUserAddToRole($event.users);
};

const updateUserAddToRole = (users) => {
  memberOfRoles.value[`${selectedRole.value}`] = uniqBy(
    memberOfRoles.value[`${selectedRole.value}`].concat(users),
    "userId",
  );
};

const addRole = () => {
  showModalAddRole.value = true;
};

const showModalAddUserToRole = (role: any) => {
  selectedRole.value = role["roleId"];
  selectedRoleName.value = role["roleName"];
  showModalAddUser.value = true;
};

const goToManageRole = (roleId) => {
  router.push({ path: `/settings/team/roles/manage/${roleId}`, replace: true });
};

const onDeleteRole = async () => {
  showModalDeleteRole.value = false;
  try {
    const res = await deleteRole(selectedRole.value);
    if (res && res.data) {
      store.dispatch("Org/setOrgRoles", res.data.data);
      const emitData: IToastMessage = {
        variant: ToastVariant.SUCCESS,
        message: getComponentUiText(
          "app-settings-team-roles-manage-role-toast-message-delete-role-success-1",
        ),
      };
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.deleteRole);
    }
  }
};
const onPageCompleted = () => {
  if (!loading.value && isLoading.value)
    EventEmitter.emit(EmitterEvents.PAGE_LOADING_COMPLETED);
};
watch(loading, onPageCompleted);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppBarLayout, null, {
    default: _withCtx(({ activeHierarchy }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BrandPattern4, {
          ref: "animation",
          page: "APPBARLAYOUT"
        }, null, 512),
        _createVNode(backgroundComponent, {
          ref_key: "backgroundRef",
          ref: backgroundRef
        }, null, 512),
        _createVNode(ActivePathWrapper, { "active-hierarchy": activeHierarchy }, null, 8, ["active-hierarchy"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(getUiText("app-settings-team-roles-manage-roles-title-1")), 1)
          ]),
          (notInfoVisible.value)
            ? (_openBlock(), _createBlock(NoteInfo, {
                key: 0,
                class: "custom-info tw-mt-[20px]",
                onClose: _cache[0] || (_cache[0] = () => (notInfoVisible.value = false))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(getUiText("app-settings-team-roles-tip-top-text-1")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(getUiText(
                          "app-settings-team-roles-manage-roles-subtitle-1",
                        )), 1)
                  ]),
                  (loading.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2], (item) => {
                          return _createElementVNode("div", {
                            key: item,
                            class: "list-container tw-mb-5"
                          }, _hoisted_16)
                        }), 64))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (role, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: role['roleId'],
                            class: "list-container tw-mb-5"
                          }, [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("span", _hoisted_19, _toDisplayString(role["roleName"]), 1),
                              _createVNode(ButtonShowMore, {
                                classes: "!tw-p-[0px]",
                                "id-popover": 
                            'popover-btn-show-more-roles-managemnet-' + index
                          ,
                                "data-cy-id": "role-management-show-more-button"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(CustomDropDownItem, {
                                    style: 'normal',
                                    "data-cy": "role-management-button-show-more",
                                    "id-text": 'app-settings-team-roles-more-modal-manage-role-1',
                                    onClick: ($event: any) => (goToManageRole(role['roleId']))
                                  }, null, 8, ["onClick"]),
                                  (memberOfRoles.value[role['roleId']]?.length === 0)
                                    ? (_openBlock(), _createBlock(CustomDropDownItem, {
                                        key: 0,
                                        style: 'danger',
                                        "id-text": 'app-settings-team-roles-more-modal-delete-role-1',
                                        onClick: ($event: any) => (showDeleteModal(role['roleId']))
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["id-popover"])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("span", null, [
                                _createElementVNode("span", _hoisted_21, _toDisplayString(getUiText(
                              "app-settings-team-roles-heading-privilege-level-1",
                            )), 1),
                                _createTextVNode("  "),
                                _createElementVNode("span", _hoisted_22, _toDisplayString(role["permissionLevel"]), 1)
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_23, _toDisplayString(getUiText(
                                "app-settings-team-roles-manage-role-form-label-mfa-required-1",
                              )) + ":", 1),
                                _createTextVNode("  "),
                                _createElementVNode("span", _hoisted_24, _toDisplayString(role["roleRequiresMFA"]
                              ? getUiText(
                                  "app-menu-submenu-home-setup-wizard-radio-button-title-yes-1",
                                )
                              : getUiText(
                                  "app-menu-submenu-home-setup-wizard-radio-button-title-no-1",
                                )), 1)
                              ]),
                              _createElementVNode("div", _hoisted_25, [
                                (
                              role['roleId'] && memberOfRoles.value[role['roleId']]
                            )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memberOfRoles.value[role['roleId']], (data) => {
                                        return (_openBlock(), _createBlock(CardRolesSetting, {
                                          key: data,
                                          data: data
                                        }, null, 8, ["data"]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(Button1, {
                                  class: "button-add",
                                  "data-cy": "role-management-add-user-to-role-button",
                                  disabled: false,
                                  title: 
                              getUiText(
                                'app-settings-team-roles-add-user-button-1',
                              )
                            ,
                                  onClick: ($event: any) => (showModalAddUserToRole(role))
                                }, null, 8, ["title", "onClick"])
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(ActionButton, {
              "profile-actions": actions,
              class: "md:tw-min-w-[241px]"
            })
          ])
        ]),
        _createVNode(ManageUserModal, {
          show: _unref(showModalDeleteRole),
          header: true,
          "red-btn": true,
          "header-title": "app-settings-team-members-profile-modal-delete-action-warning-1",
          "contain-title": "app-settings-team-roles-manage-role-delete-role-action-title-1",
          "contain-sub-title": "app-settings-team-roles-manage-role-delete-role-action-helper-a-1",
          "action-title": "app-settings-team-roles-manage-role-delete-role-action-title-1",
          "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showModalDeleteRole) //@ts-ignore
 ? showModalDeleteRole.value = $event : showModalDeleteRole = $event)),
          "onUpdate:actionHandle": onDeleteRole
        }, null, 8, ["show"]),
        _createVNode(AddRoleModal, {
          show: showModalAddRole.value,
          "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (showModalAddRole.value = $event))
        }, null, 8, ["show"]),
        _createVNode(AddUserRoleModal, {
          show: showModalAddUser.value,
          "role-id": selectedRole.value,
          "role-name": selectedRoleName.value,
          "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (showModalAddUser.value = $event)),
          "onAdd:userToRole": handleAddUserToRole
        }, null, 8, ["show", "role-id", "role-name"])
      ])
    ]),
    _: 1
  }))
}
}

})